import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { ProfileEmails } from "@/components/profiles/profile-emails";

const ProfileEmailsPage = () => {
  return <ProfileEmails />;
};

export const Route = createFileRoute("/_private/profiles/$id/emails/")({
  component: ProfileEmailsPage,
  validateSearch: z.object({
    page: z.coerce.number().int().min(1).optional().catch(undefined),
  }),
});
